import dayjs from "dayjs";

export const MONTH_CODE = {
    January  : "1",
    February : "2",
    March    : "3",
    April    : "4",
    May      : "5",
    June     : "6",
    July     : "7",
    August   : "8",
    September: "9",
    October  : "10",
    November : "11",
    December : "12"
};

export const CURRENT_MONTH = MONTH_CODE[dayjs().format("MMMM")];
export const CURRENT_YEAR = dayjs().format("YYYY");

